export const PLATFORMS = [
  { id: 'x',          label: 'X (Twitter)',  color: '#000000', charLimit: 280 },
  { id: 'instagram',  label: 'Instagram',    color: '#E1306C', charLimit: 2200 },
  { id: 'facebook',   label: 'Facebook',     color: '#1877F2', charLimit: 63206 },
  { id: 'tiktok',     label: 'TikTok',       color: '#010101', charLimit: 2200 },
  { id: 'reddit',     label: 'Reddit',       color: '#FF4500', charLimit: 40000 },
  { id: 'nextdoor',   label: 'Nextdoor',     color: '#8DB600', charLimit: 1500 },
  { id: 'linkedin',   label: 'LinkedIn',     color: '#0A66C2', charLimit: 3000 },
  { id: 'threads',    label: 'Threads',      color: '#000000', charLimit: 500 },
  { id: 'bluesky',    label: 'Bluesky',      color: '#0085FF', charLimit: 300 },
  { id: 'youtube',    label: 'YouTube',      color: '#FF0000', charLimit: 5000 },
  { id: 'pinterest',  label: 'Pinterest',    color: '#E60023', charLimit: 500 },
  { id: 'discord',    label: 'Discord',      color: '#5865F2', charLimit: 2000 },
  { id: 'telegram',   label: 'Telegram',     color: '#2AABEE', charLimit: 4096 },
  { id: 'email_outreach', label: 'Email Outreach', color: '#6B7280', charLimit: 10000 },
  { id: 'data_study',     label: 'Data Study',     color: '#7C3AED', charLimit: 20000 },
] as const;

export const FAMILY_MEMBERS = ['Trent', 'Holli', 'Jessica', 'Mom', 'Caleb'] as const;

export const ACCOUNT_STATUSES = [
  { id: 'pending_setup', label: 'Pending Setup', color: 'bg-yellow-100 text-yellow-800' },
  { id: 'active',        label: 'Active',         color: 'bg-green-100 text-green-800' },
  { id: 'suspended',     label: 'Suspended',      color: 'bg-red-100 text-red-800' },
  { id: 'deactivated',   label: 'Deactivated',    color: 'bg-gray-100 text-gray-600' },
];

export const CAMPAIGN_STATUSES = [
  { id: 'draft',     label: 'Draft',     color: 'bg-gray-100 text-gray-700' },
  { id: 'active',    label: 'Active',    color: 'bg-green-100 text-green-800' },
  { id: 'paused',    label: 'Paused',    color: 'bg-yellow-100 text-yellow-800' },
  { id: 'completed', label: 'Completed', color: 'bg-blue-100 text-blue-800' },
];

export const CAMPAIGN_TYPES = [
  { id: 'launch',               label: 'Account Launch' },
  { id: 'content',              label: 'Content Series' },
  { id: 'outreach',             label: 'Outreach / Backlinks' },
  { id: 'seo',                  label: 'SEO / Technical' },
  { id: 'data_study',           label: 'Data Study / PR' },
  { id: 'partnership',          label: 'Partnership' },
  { id: 'hospital_rankings',    label: 'Hospital Rankings' },
  { id: 'procedure_spotlight',  label: 'Procedure Spotlight' },
  { id: 'awareness',            label: 'Awareness' },
  { id: 'response',             label: 'Response' },
];

export const POST_STATUSES = [
  { id: 'draft',            label: 'Draft',            color: 'bg-gray-100 text-gray-700' },
  { id: 'pending_approval', label: 'Pending Approval', color: 'bg-yellow-100 text-yellow-800' },
  { id: 'approved',         label: 'Approved',         color: 'bg-green-100 text-green-800' },
  { id: 'denied',           label: 'Denied',           color: 'bg-red-100 text-red-800' },
  { id: 'posted',           label: 'Posted',           color: 'bg-blue-100 text-blue-800' },
  { id: 'failed',           label: 'Failed',           color: 'bg-orange-100 text-orange-800' },
];

export const GEO_TYPES = [
  { id: 'national', label: 'National' },
  { id: 'state',    label: 'State' },
  { id: 'city',     label: 'City' },
];

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
  'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
  'VT','VA','WA','WV','WI','WY',
];

export const MAJOR_CITIES = [
  'New York, NY', 'Los Angeles, CA', 'Chicago, IL', 'Houston, TX', 'Phoenix, AZ',
  'Philadelphia, PA', 'San Antonio, TX', 'San Diego, CA', 'Dallas, TX', 'Austin, TX',
  'Jacksonville, FL', 'Fort Worth, TX', 'Columbus, OH', 'Indianapolis, IN', 'Charlotte, NC',
  'San Francisco, CA', 'Seattle, WA', 'Denver, CO', 'Nashville, TN', 'Oklahoma City, OK',
  'El Paso, TX', 'Las Vegas, NV', 'Louisville, KY', 'Baltimore, MD', 'Milwaukee, WI',
  'Albuquerque, NM', 'Tucson, AZ', 'Fresno, CA', 'Sacramento, CA', 'Kansas City, MO',
  'Atlanta, GA', 'Miami, FL', 'Raleigh, NC', 'Omaha, NE', 'Minneapolis, MN',
  'Tampa, FL', 'New Orleans, LA', 'Portland, OR', 'Boston, MA', 'Detroit, MI',
];

export function getPlatformConfig(id: string) {
  return PLATFORMS.find(p => p.id === id);
}

export function getPlatformColor(id: string): string {
  return getPlatformConfig(id)?.color ?? '#6b7280';
}

export function getPlatformLabel(id: string): string {
  return getPlatformConfig(id)?.label ?? id;
}

export function getStatusConfig(
  statuses: { id: string; label: string; color: string }[],
  id: string
) {
  return statuses.find(s => s.id === id);
}
